/**
 * Manual cache version for persistent resolved-manifest cache entries.
 * Bump this value when @wix/component-protocol enrichment behavior changes
 * to invalidate stale cached manifests.
 */
export const COMPONENT_PROTOCOL_VERSION =
  '1752773a1c179618849ad7df520c862b17544514daf1c4c96686b3174';
